var ServicesEnum;
(function (ServicesEnum) {
    ServicesEnum["passport"] = "passport";
    ServicesEnum["traderProfile"] = "traderProfile";
    ServicesEnum["binancePublic"] = "binancePublic";
    ServicesEnum["binancePublicFutures"] = "binancePublicFutures";
    ServicesEnum["traderProfileV2"] = "traderProfileV2";
    ServicesEnum["screener"] = "screener";
})(ServicesEnum || (ServicesEnum = {}));
export default ServicesEnum;
